import React, { memo, useCallback, useState } from 'react'

import { Notice } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import useGetLibraryItems from 'Pods/ThreeDStudio/Components/Sidebar/Components/LibraryContent/Hooks/useGetLibraryItems'
import { AI_TERMS_OF_SERVICE_HREF } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const STORAGE_KEY = 'ai_terms_of_service_notice_closed'

const hasBeenClosed = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  } catch (_) {
    return false
  }
}

const markClosed = () => {
  try {
    window.localStorage.setItem(STORAGE_KEY, 'true')
  } catch (_) {
    // Storage may be unavailable (private mode, quota). Treat as no-op.
  }
}

function TermsOfServiceNotice() {
  const t = useTranslation()
  const { isCurrentUser: isLoggedIn } = usePageConfig() || {}
  const { items, isLoading } = useGetLibraryItems(isLoggedIn, '')
  const [dismissed, setDismissed] = useState(hasBeenClosed)

  const handleClose = useCallback(() => {
    markClosed()
    setDismissed(true)
  }, [])

  if (!isLoggedIn || dismissed || isLoading || items.length > 0) {
    return null
  }

  return (
    <div className="terms-of-service-notice" role="status" aria-live="polite">
      {/* useSSRIcon with no ssrIcon: skips the default lead icon and keeps the close icon SSR-safe */}
      <Notice useSSRIcon onClose={handleClose}>
        <span className="cgt-body-base">
          {t('viewer.termsOfServiceNotice.lead')}
          {' '}
          <a
            href={AI_TERMS_OF_SERVICE_HREF}
            target="_blank"
            rel="noopener noreferrer"
            className="cgt-link-primary-accented"
          >
            {t('viewer.termsOfServiceNotice.link')}
          </a>
          .
        </span>
      </Notice>
    </div>
  )
}

export default memo(TermsOfServiceNotice)
